



















































import '@/assets/scss/pages/dashboard-ecommerce.scss';
import { Component, Watch } from 'vue-property-decorator';
import {
  ChevronDownIcon,
  ChevronUpIcon,
  FilterIcon,
  GridIcon,
  UserIcon,
  XIcon,
} from 'vue-feather-icons';
import { DateFilter, IUser, TaskFilterDto, TaskStatus } from 'admiral-core';
import { FilterMixin } from '@/mixins/FilterMixin';
import { mixins } from 'vue-class-component';
import { PreferencesAction } from '@/store/PreferencesModule';
import DateFilterComponent from '@/components/filters/DateFilter.vue';
import UserFilterComponent from '@/components/filters/UserFilter.vue';
import PolicyStatusFilterComponent from '@/components/filters/PolicyStatusFilter.vue';
import HorizontalPolicyStatusSelect from '@/views/pages/policies/HorizonalPolicyStatusSelect.vue';
import { Util } from '@/utils/Util';

@Component({
  components: {
    HorizontalPolicyStatusSelect,
    'date-filter': DateFilterComponent,
    'user-filter': UserFilterComponent,
    'policy-status-filter': PolicyStatusFilterComponent,
    FilterIcon,
    ChevronDownIcon,
    ChevronUpIcon,
    UserIcon,
    XIcon,
    GridIcon,
  },
})
export default class TaskFilterComponent extends mixins(FilterMixin) {
  filter: TaskFilterDto = {
    dateFilter: DateFilter.ALL,
    status: [TaskStatus.TODO],
    users: [],
  };

  get isDefaultFilter() {
    return this.filter.dateFilter === DateFilter.ALL && this.filter.users?.length === 0;
  }

  updateDateFilter(filter: { dateFilter: DateFilter; from: number; to: number }) {
    this.filter.dateFilter = filter.dateFilter;
    if (filter.from) {
      this.filter.from = filter.from;
    }
    if (filter.to) {
      this.filter.to = filter.to;
    }
    this.updateFilter();
  }

  updateUserFilter(users: IUser[]) {
    this.filter.users = [...users];
    this.updateFilter();
  }

  resetFilter() {
    this.filter = {
      dateFilter: DateFilter.ALL,
      users: [],
      status: [TaskStatus.TODO],
    };
    this.filter.users = [];
    this.filter.dateFilter = DateFilter.ALL;
    this.updateFilter();
    this.$root.$emit('reset-task-filter');
  }

  async mounted() {
    try {
      this.filter = await this.$store.getters['PreferencesModule/getTaskFilter'];
    } catch (e) {
      this.$toastr.e('Beim Abrufen der Produkte und Mitarbeiter ist etwas schiefgelaufen.');
    }

    this.$root.$on('update-task-filter', async () => {
      await this.updateFilter();
    });
  }

  async updateFilter() {
    if (this.filter.users && !Array.isArray(this.filter.users)) {
      this.filter.users = [this.filter.users];
    }

    // TODO: workaround (get status from buttons first)
    const filter = (await this.$store.getters['PreferencesModule/getTaskFilter']) as TaskFilterDto;

    await this.$store.dispatch(`PreferencesModule/${PreferencesAction.setTaskFilter}`, this.filter);
    this.close();
  }

  selectedFilterString() {
    let str = '';

    // if (!this.isDefaultFilter || this.filter.dateFilter !== DateFilter.ALL) {
    //   str += this.dateFilterNames(this.filter.dateFilter!) + ', ';
    // }

    if (this.filter.users && this.filter.users.length > 0) {
      str += this.filter.users[0].firstname + ', ';
    }
    // if (!this.isDefaultFilter) {
    //   this.filter.status?.forEach((status: PolicyStatus) => {
    //     str += this.statusFilterNames(status) + ', ';
    //   });
    // }

    return str.substr(0, str.length - 2);
  }

  get filterFromStore(): TaskFilterDto {
    return this.$store.getters['PreferencesModule/getTaskFilter'] as TaskFilterDto;
  }

  @Watch('filterFromStore')
  watchFilterFromStore() {
    this.filter = this.filterFromStore;
  }

  onOver() {
    (this.$refs as any).dropdown.visible = true;
  }
  onLeave(evt: Event) {
    (this.$refs as any).dropdown.visible = false;
  }

  get isMobile() {
    return Util.isMobile();
  }
}
